class IconPath {
  /**
   * Gets full path for SVG icon from S3 bucket hosted in https://files.connectwise.com
   * 
   * @static
   * @param {string} icon 
   * @returns {string}
   * @memberof IconPath
   */
  static get(icon) {
    return `https://files.connectwise.com/UI/Icons/v1.0/${icon}.svg`;
  }
}

export default IconPath;


// WEBPACK FOOTER //
// ./src/utils/IconPath.js